var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM17.5496 9.50985C17.8314 9.20632 17.8139 8.73177 17.5103 8.44992C17.2068 8.16806 16.7323 8.18564 16.4504 8.48917L10.48 14.9188L7.53033 11.9692C7.23744 11.6763 6.76256 11.6763 6.46967 11.9692C6.17678 12.2621 6.17678 12.7369 6.46967 13.0298L9.96967 16.5298C10.1137 16.6739 10.3102 16.7532 10.5139 16.7494C10.7176 16.7456 10.911 16.6591 11.0496 16.5098L17.5496 9.50985Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircle);
export default __webpack_public_path__ + "static/media/checkmark-circle.0f9a5d2f1d642f5ab28e778e7bf7b97c.svg";
export { ForwardRef as ReactComponent };